$('.help-collapse-hd').click(function () { 
  $(this).parent().siblings().find('.help-collapse-bd').slideUp()
  $(this).parent().siblings().find('.help-collapse-hd').removeClass('active')
  $(this).next().slideToggle();
  $(this).toggleClass('active')
});


$('.help-faq-sidebar li').click(function(){
  if(isMobile()){
    
    $('.help-faq-default').val($(this).children('span').text())
  }
  $(this).addClass('active').siblings().removeClass('active');
  $('.help-faq-list .help-faq-item').eq($(this).index()).addClass('active').siblings().removeClass('active');
})

$('.help-faq-sidebar').click(function(){
  if(isMobile()){
    $('.help-tabs-list').slideToggle();
    $(this).find('.iconfont').toggleClass('active');
  }
})




$('document').ready(function(){
  console.log($('.help-tabs-list').children('.active').children('.active').text());
  $('.help-faq-default').val($('.help-tabs-list').children('.active').children('span').text());
})